import ActionModal from './ActionModal'

interface DevelopingModalProps {
  isOpen: boolean
  onClose: () => void
}

/**
 * 功能开发中弹窗
 * 使用通用的 ActionModal 实现
 */
export default function DevelopingModal(props: DevelopingModalProps) {
  return (
    <ActionModal
      isOpen={props.isOpen}
      onClose={props.onClose}
      title='Coming Soon'
      description={
        <>
          This feature is currently under development. <br />
          Stay tuned for updates!
        </>
      }
      confirmText='Got it'
      confirmTestId='developing-modal-close'
      testId='developing-modal'
    />
  )
}
